import { Vestiging } from "@/entities/vestiging";
import { createColumnHelper } from "@tanstack/react-table";
import { NameCol, OpeningHoursCol, VestigingenUpdateHandler } from "../../shared";
import type { FaciliteitenTableFeatures } from "../../shared/faciliteiten-table-features";
import { LokaleVestigingenBadgeAndButton, MenuCol, ToelichtingCol } from "./columns";

export type Handlers = {
    onVestigingUpdate: VestigingenUpdateHandler;
    onLocalToelichtingChange?: (vestiging: Vestiging, toelichting: string) => void;
};

export const createColumns = (variant: "startNsRetailVestiging" | "stopNsRetailVestiging" | "lokaleVestiging", handlers: Handlers) => {
    const columnHelper = createColumnHelper<FaciliteitenTableFeatures, Vestiging>();
    switch (variant) {
        case "startNsRetailVestiging":
        case "stopNsRetailVestiging":
            return columnHelper.columns([
                columnHelper.accessor("beheerVestiging.vestigingNaam", {
                    cell: ({ row }) => <NameCol variant="klantenservice" vestiging={row.original} />,
                }),
                columnHelper.accessor("currentOpeningstijden", {
                    cell: ({ row }) => <OpeningHoursCol vestiging={row.original} />,
                }),
                columnHelper.display({
                    id: "toelichting",
                    cell: ({ row }) => <ToelichtingCol vestiging={row.original} />,
                }),
                columnHelper.display({
                    id: "menu",
                    cell: ({ row }) => (
                        <MenuCol
                            vestiging={row.original}
                            variant={variant}
                            onVestigingUpdate={handlers.onVestigingUpdate}
                            onToelichtingChange={handlers.onLocalToelichtingChange!}
                        />
                    ),
                }),
            ]);
        case "lokaleVestiging":
            return columnHelper.columns([
                columnHelper.accessor("beheerVestiging.vestigingNaam", {
                    cell: ({ row }) => <NameCol variant="klantenservice" vestiging={row.original} />,
                }),
                columnHelper.accessor("currentOpeningstijden", {
                    cell: ({ row }) => <OpeningHoursCol vestiging={row.original} />,
                }),
                columnHelper.display({
                    id: "lokaleVestigingenBadgeAndButton",
                    cell: ({ row }) => (
                        <LokaleVestigingenBadgeAndButton vestiging={row.original} onVestigingUpdate={handlers.onVestigingUpdate} />
                    ),
                }),
            ]);
    }
};
